<template>
  <v-app id="inspire">
    <div class="screen-only">
      <v-navigation-drawer v-model="drawer" fixed app v-if="isLoggedIn">
        <v-list dense>
          <v-list-tile :to="item.to" v-for="item in items" :key="item.name">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider />
        <v-list dense>
          <v-list-tile :to="item.to" v-for="item in managerItems" :key="item.name">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider />
        <v-list dense>
          <v-list-tile :to="item.to" v-for="item in spItems" :key="item.name">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.title}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar color="indigo" class="white--text" dark fixed app>
        <v-toolbar-side-icon @click.stop="drawer = !drawer" v-if="isLoggedIn"></v-toolbar-side-icon>
        <v-toolbar-title>MFP System</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down" v-if="isLoggedIn">
          <v-menu>
            <v-btn icon slot="activator">
              <v-icon>account_box</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                :to="{name:'change_password', params:{company_id:this.$route.params.company_id}}"
              >
                <v-list-tile-title>パスワード変更</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title v-on:click.stop="logOutAndToLogin">ログアウト</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </div>
    <v-content id="main-content">
      <v-container fluid>
        <loading :isLoading="isLoading" />
        <router-view />
      </v-container>
    </v-content>
    <v-footer color="indigo" app v-if="showHeaderAndFooter" class="screen-only">
      <span class="white--text">&copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
import auth from '@/components/fireAuthInit'
import Loading from "@/components/loading.vue"
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  name: 'App',
  components: { Loading },
  data() {
    return {
      drawer: false,
      //isLoading: true,
      showHeaderAndFooter: true,
      spItems: [
        //{ to: { name: "companies" }, icon: "domain", title: "会社一覧" },
      ],


    }
  },
  computed: {
    items() {
      return (
        [
          { to: { name: "home" }, params: { company_id: this.$route.params.company_id }, icon: "home", title: "ホーム" },
          { to: { name: "results" }, params: { company_id: this.$route.params.company_id }, icon: "assignment", title: "サーベイ結果" },
          { to: { name: "targets" }, params: { company_id: this.$route.params.company_id }, icon: "trending_up", title: "目標設定" },
        ]
      )
    },
    managerItems() {
      const items =[]
      if(this.user.role == "manager" || "sp"){
          items.push({ to: { name: "manage_surveys" }, params: { company_id: this.$route.params.company_id }, icon: "folder_open", title: "サーベイ目標管理" })
      }
      if(this.user.role == "sp"){
         items.push( { to: { name: "users" }, params: { company_id: this.$route.params.company_id }, icon: "group", title: "ユーザー管理" })
      }
      return items
        
    },
    ...mapGetters('auth', ['isLoggedIn', 'user', 'toUrl']),
    ...mapGetters('app', ['isLoading'])
  },
  methods: {
    logOutAndToLogin() {
      this.logOut()
      this.$router.push({ name: "login", params: { company_id: this.$route.params.company_id } })
    },
    ...mapActions('auth', ["logOut"]),
  },
  mounted() {
  },
  created() {
  },
  updated() {

  }
}
</script>
<style lang="scss" scoped>
@media print {
  .screen-only {
    display: none;
  }
}
</style>

